import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=5194fba4&scoped=true&"
import script from "./MenuContent.vue?vue&type=script&lang=js&"
export * from "./MenuContent.vue?vue&type=script&lang=js&"
import style0 from "./MenuContent.vue?vue&type=style&index=0&id=5194fba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194fba4",
  null
  
)

export default component.exports